import { Link } from '@tanstack/react-router';
import GridCellExpanderRenderer from '@zeus/core/grid/GridCellExpanderRenderer';
import { featureFlags } from '_/constants/loginPools.constants';
import { ILoginPoolRow } from '_/types/loginPools';
import Button from 'antd/lib/button';
import Popover from 'antd/lib/popover';
import { ColumnType } from 'antd/lib/table';
import Tooltip from 'antd/lib/tooltip';
import React, { useMemo } from 'react';

export const useColumnDefs = (): ColumnType<ILoginPoolRow>[] => {
  return useMemo(() => getColumnDefs(), []);
};

const getColumnDefs = (): ColumnType<ILoginPoolRow>[] => {
  const columnDefs: ColumnType<ILoginPoolRow>[] = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (name: string, row: ILoginPoolRow) => (
        <Link to={row.href} className="wb-textDecoration-underline">
          {name}
        </Link>
      ),
    },
    {
      title: 'Created On',
      dataIndex: 'addedAt',
      key: 'addedAt',
      render: (addedAt: string, row: ILoginPoolRow) => (
        <Tooltip title={row.addedAtFull}>
          <span>{addedAt}</span>
        </Tooltip>
      ),
    },
  ];

  if (featureFlags.parameters) {
    columnDefs.push({
      title: 'Parameters',
      dataIndex: 'parameters',
      key: 'parameters',
      render: (params) => <GridCellExpanderRenderer title="Parameters" value={params} />,
    });
  }

  if (featureFlags.sources) {
    columnDefs.push({
      title: 'Sources',
      dataIndex: 'id',
      key: 'id',
      render: () => {
        return (
          <Popover title="Sources" trigger="click" content={<span>Not implemented yet</span>}>
            <Button>View Sources</Button>
          </Popover>
        );
      },
    });
  }

  return columnDefs;
};
